module.exports = __webpack_public_path__ + "img/02.0e6a7db7.png";